/* 786 Cosmetics PDP redesign (individual-polish) - Oct 2026.
 * Single -> 4/6 piece set upgrade. Cart format matches the existing set flow:
 *   set variant + properties {"_bundle-set":"true","Color 1":"<Shade> - Breathable Nail Polish", ...}
 * Creates no discounts. Display prices come from the snippet's JSON. */
(function () {
  if (window.__s786pdp) return; window.__s786pdp = true;
  var root = document.getElementById('s786pdp'); if (!root) return;
  var D = JSON.parse(document.getElementById('s786pdp-data').textContent);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  var state = { pack: 1, picks: [], edit: -1, last: '' };
  var swatches = $$('.s786pdp__sw', root);
  var byId = {}; swatches.forEach(function (b) { if (!byId[b.dataset.id]) byId[b.dataset.id] = b; });
  document.body.classList.add('s786pdp-on');

  /* ---------- remember original header bits ---------- */
  var titleEl = $('.product__title'), priceEl = $('.product__price'), descEl = $('.product__description'),
      crumbEl = $('.breadcrumbs__current'), crumbLink = null;
  var orig = { title: titleEl && titleEl.textContent, price: priceEl && priceEl.innerHTML, desc: descEl && descEl.innerHTML, crumb: crumbEl && crumbEl.textContent };

  /* "$13.99 USD" with a small USD, like the design (Conversion Bear writes the .money text) */
  function smallUsd() {
    if (!priceEl || state.pack !== 1) return;
    $$('[data-price] .money, [data-price]', priceEl).forEach(function (m) {
      if (m.querySelector('.money') || m.querySelector('.s786pdp-usd')) return;
      var t = m.textContent.trim(), mm = t.match(/^(.*?\d)\s*([A-Z]{3})$/);
      if (mm) m.innerHTML = mm[1] + '<span class="s786pdp-usd">' + mm[2] + '</span>';
    });
  }
  [1500, 4000, 8000].forEach(function (ms) { setTimeout(smallUsd, ms); });
  function singlePrice() {
    if (!priceEl) return;
    priceEl.innerHTML = orig.price;
    smallUsd();
  }

  /* ---------- announcement bar ---------- */
  var ann = $('.announcement-bar');
  if (ann && D.banner && !$('.s786pdp-ann', ann)) { var annEl = document.createElement('div'); annEl.className = 's786pdp-ann'; annEl.textContent = D.banner; ann.insertBefore(annEl, ann.firstChild); document.body.classList.add('s786pdp-ann-on'); }

  /* ---------- wishlist heart next to the title (drives the existing wishlist app button) ---------- */
  var hdr = $('.product__block--product-header-inner');
  if (hdr && titleEl && !$('.s786pdp-heart')) {
    var heart = document.createElement('button');
    heart.type = 'button'; heart.className = 's786pdp-heart'; heart.setAttribute('aria-label', 'Add to wishlist');
    heart.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20.3s-7.5-4.6-9.3-9.2C1.4 7.7 3.6 4.3 7 4.3c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.4 0 5.6 3.4 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>';
    hdr.appendChild(heart);
    var placeHeart = function () { heart.style.top = (titleEl.offsetTop + 2) + 'px'; };
    placeHeart(); window.addEventListener('resize', placeHeart);
    var wl = function () { return $('.nm-PRODUCT_PAGE-wishlist-button') || $('.nm-wishlist-button') || $('klaviyo-favorites-button button'); };
    var syncHeart = function () { var b = wl(); var txt = b ? ((b.className || '') + ' ' + (b.getAttribute('aria-pressed') || '') + ' ' + (b.getAttribute('aria-label') || '') + ' ' + b.textContent) : ''; var on = !!b && /in[\s-]*(your\s+)?wishlist|added|--active|is-active|remove from|saved/i.test(txt) && !/^\s*add to wishlist\s*$/i.test(b.textContent); heart.classList.toggle('is-on', on); heart.setAttribute('aria-pressed', on); };
    heart.addEventListener('click', function () { var b = wl(); if (b) { b.click(); setTimeout(syncHeart, 600); setTimeout(syncHeart, 1800); } });
    // keep the heart in sync with the app button (on load and after saves)
    var watched = null, tries = 0;
    var watch = function () {
      var b = wl();
      if (b && b !== watched) { watched = b; new MutationObserver(syncHeart).observe(b, { attributes: true, childList: true, subtree: true, characterData: true }); }
      syncHeart();
      if (!watched && tries++ < 40) setTimeout(watch, 500);
    };
    watch(); setTimeout(syncHeart, 3000); setTimeout(syncHeart, 6000);
    state.placeHeart = placeHeart;
  }

  /* ---------- set gallery (left column) ---------- */
  var left = $('.product__primary-left'), gal = null;
  if (left) {
    gal = document.createElement('div'); gal.className = 's786pdp-gal';
    left.insertBefore(gal, left.firstChild);
    /* "Your picks" slots: empty -> go to the picker; filled -> go to the picker in replace mode for that slot */
    gal.addEventListener('click', function (e) {
      var b = e.target.closest('[data-slot]'); if (!b || state.pack === 1) return;
      var i = +b.dataset.slot;
      state.edit = state.picks[i] ? i : -1;
      msg(''); render(); goPicker();
    });
  }
  function goPicker() {
    var pk = $('#s786pdp-picker'); if (!pk || pk.hidden) return;
    var head = $('.s786pdp__picker-head', pk) || pk;
    var off = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--s786-hdr'), 10) || 100;
    window.scrollTo({ top: head.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
    pk.classList.remove('is-flash'); void pk.offsetWidth; pk.classList.add('is-flash');
    clearTimeout(state.flashT); state.flashT = setTimeout(function () { pk.classList.remove('is-flash'); }, 1600);
  }
  (function () { var g = $('[data-s786-giftimg]', root); if (g) ['4', '6'].forEach(function (k) { var s = g.getAttribute('data-src' + k); if (s) (new Image()).src = s; }); })();
  $$('[data-s786-addon]', root).forEach(function (cb) { var l = cb.closest('.s786pdp__addon'); var f = function () { if (l) l.classList.toggle('is-on', cb.checked); }; cb.addEventListener('change', f); f(); });
  function renderGallery(n) {
    if (!gal) return;
    var s = D.sets[n] || {};
    if (gal.dataset.n !== String(n)) {
      gal.dataset.n = n;
      gal.className = 's786pdp-gal s786pdp-gal--' + n + (s.hero ? ' has-hero' : '');
      gal.innerHTML = (s.hero ? '<figure class="s786pdp-gal__hero"><img src="' + s.hero + '" alt="' + n + '-piece nail polish set in the 786 gift box"></figure>' +
          '<p class="s786pdp-gal__picks-h">Your picks</p><div class="s786pdp-gal__picks"></div>'
        : '<div class="s786pdp-gal__grid">' + D.examples.slice(0, n).map(function (u) { return '<img src="' + u + '" alt="" loading="lazy">'; }).join('') +
          '</div><p class="s786pdp-gal__cap">Choose your colors. Shades shown are an example.</p>');
    }
    var strip = gal.querySelector('.s786pdp-gal__picks');
    if (strip) {
      var h = ''; for (var i = 0; i < n; i++) { var p = state.picks[i];
        h += p ? '<button type="button" class="s786pdp-gal__pk' + (state.edit === i ? ' is-edit' : '') + '" data-slot="' + i + '" aria-label="Shade ' + (i + 1) + ': ' + p.name + '. Tap to change"><img src="' + (p.bottle || p.img) + '" alt=""><b>' + (i + 1) + '</b></button>'
               : '<button type="button" class="s786pdp-gal__pk is-empty" data-slot="' + i + '" aria-label="Shade ' + (i + 1) + ': empty. Tap to choose a shade"><b>' + (i + 1) + '</b></button>'; }
      strip.innerHTML = h;
    }
  }

  /* ---------- render ---------- */
  function setHeader() {
    var n = state.pack;
    if (n === 1) {
      if (titleEl) titleEl.textContent = orig.title;
      singlePrice();
      if (descEl) descEl.innerHTML = orig.desc;
      if (crumbEl) { crumbEl.textContent = orig.crumb; }
      if (crumbLink) { crumbLink.remove(); crumbLink = null; }
    } else {
      var s = D.sets[n];
      if (titleEl) titleEl.textContent = s.title;
      if (priceEl) {
        priceEl.innerHTML = '<div class="s786pdp-hp">' + (s.was > 0 ? '<s>' + money(s.was) + '</s>' : '') +
          '<span class="s786pdp-hp-big">' + money(s.offer) + '</span><span class="s786pdp-hp-usd">USD</span>' +
          '</div>';
      }
      if (descEl) descEl.innerHTML = '<div class="rte rte--product"><p>Create your own ' + n + '-piece set. Choose ' + n + ' of your favorite shades from our breathable nail polish collection.</p><p>Pick your colors below, then add your set to bag.</p></div>';
      if (crumbEl) crumbEl.textContent = 'Nail Polish Sets';
    }
    if (state.placeHeart) setTimeout(state.placeHeart, 0);
  }

  function render() {
    var n = state.pack, set = n > 1;
    document.body.classList.toggle('s786pdp-set', set);
    root.classList.toggle('is-single', !set);
    $$('.s786pdp__opt', root).forEach(function (o) { var on = +o.dataset.pack === n; o.classList.toggle('is-on', on); o.setAttribute('aria-checked', on); });
    $('#s786pdp-picker').hidden = !set; $('#s786pdp-review').hidden = !set;
    setHeader();
    var atb = $('[data-s786-atb]', root);
    var sold = $('[data-s786-soldnote]', root); if (sold) sold.hidden = set;
    if (!set) { var ok = D.single.available !== false; atb.disabled = !ok; atb.textContent = ok ? 'Add to Bag' : 'Sold out'; postRender(); return; }
    atb.disabled = false;
    var s = D.sets[n], k = state.picks.length;
    $$('[data-s786-count]', root).forEach(function (e) { e.textContent = k; });
    $$('[data-s786-n]', root).forEach(function (e) { e.textContent = n; });
    var bar = $('[data-s786-bar]', root); var h = ''; for (var i = 0; i < n; i++) h += '<i class="' + (i < k ? 'on' : '') + '"></i>'; bar.innerHTML = h;
    var st = $('[data-s786-status]', root);
    if (state.edit >= 0) st.innerHTML = 'Pick a shade to replace #' + (state.edit + 1) + '. <button type="button" class="s786pdp__undo" data-s786-cancel>Cancel</button>';
    else st.textContent = k >= n ? 'All ' + n + ' shades picked. Ready to review.' : (k === 0 ? 'Pick ' + n + ' shades.' : 'Pick ' + (n - k) + ' more shade' + (n - k > 1 ? 's' : '') + '.');
    root.classList.toggle('is-full', k >= n); root.classList.toggle('is-editing', state.edit >= 0);
    swatches.forEach(function (b) { b.classList.remove('is-on'); b.removeAttribute('aria-pressed'); });
    state.picks.forEach(function (p, i) { swatches.forEach(function (b) { if (b.dataset.id === p.id) { b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); $('.s786pdp__num', b).textContent = i + 1; } }); });
    $('[data-s786-selected]', root).textContent = state.last ? 'Selected: ' + state.last : '';
    var rows = ''; for (var j = 0; j < n; j++) {
      var p = state.picks[j];
      rows += p ? '<li class="s786pdp__row"><span class="s786pdp__row-n">' + (j + 1) + '</span><img src="' + p.img + '" alt=""><span class="s786pdp__row-name">' + p.name + '</span><button type="button" class="s786pdp__row-edit" data-edit="' + j + '">Edit</button></li>'
        : '<li class="s786pdp__row is-empty"><span class="s786pdp__row-n">' + (j + 1) + '</span><span class="s786pdp__row-ph"></span><span class="s786pdp__row-name">Pick shade ' + (j + 1) + '</span></li>';
    }
    $('[data-s786-rows]', root).innerHTML = rows;
    if (state.rebuildIO) state.rebuildIO();
    $('[data-s786-list]', root).textContent = money(s.was || s.price);
    $('[data-s786-list]', root).parentNode.hidden = !(s.was > 0);
    $('[data-s786-with]', root).textContent = (s.was > 0 ? 'Set price: ' : '') + money(s.offer) + ' USD';
    $('[data-s786-ship]', root).hidden = !(s.offer >= D.freeShip);
    $('[data-s786-per]', root).textContent = money(s.per) + ' per shade' + (s.save > 0 ? ' - save ' + money(s.save) + (D.saveLabel == null ? ' vs singles' : D.saveLabel) : '');
    renderGallery(n);
    var gimg = $('[data-s786-giftimg]', root); if (gimg) { var gs = gimg.getAttribute('data-src' + n); if (gs && gimg.getAttribute('src') !== gs) { gimg.src = gs; gimg.alt = '786 ' + n + '-piece gift box'; } }
    atb.textContent = k >= n ? 'Add set to Bag' : 'Pick ' + (n - k) + ' more shade' + (n - k > 1 ? 's' : '');
    postRender();
  }

  function pickFromButton(b) { return { id: b.dataset.id, title: b.dataset.title, name: b.dataset.name, img: b.dataset.img, bottle: b.dataset.bottle }; }

  function setPackUrl(n) { try { var u = new URL(location.href); if (n > 1) u.searchParams.set('pack', n); else u.searchParams.delete('pack'); history.replaceState(history.state, '', u); } catch (e) {} }
  /* 4 set full + a 5th shade tapped -> move to the 6 set, keep picks in order, offer Undo */
  function upgradeTo6(b) {
    state.pack = 6; state.edit = -1; state.upgraded = true;
    clearTimeout(state.upT); var un = $('[data-s786-upnote]', root); if (un) un.classList.remove('is-undone');
    state.picks.push(pickFromButton(b)); state.last = b.dataset.name;
    msg(''); render(); setPackUrl(6);
  }
  function undoUpgrade() {
    state.upgraded = false; state.pack = 4; state.edit = -1;
    state.picks = state.picks.slice(0, 4); state.last = state.picks.length ? state.picks[state.picks.length - 1].name : '';
    msg(''); render(); setPackUrl(4);
    var nn = $('[data-s786-upnote]', root); if (nn) { nn.querySelector('span').textContent = 'Back to the 4 set.'; nn.querySelector('button').hidden = true; nn.hidden = false; nn.classList.add('is-undone'); clearTimeout(state.upT); state.upT = setTimeout(function () { nn.hidden = true; nn.classList.remove('is-undone'); }, 2500); }
  }
  function renderUpNote() {
    var st = $('[data-s786-status]', root); if (!st) return;
    var nn = $('[data-s786-upnote]', root);
    if (!nn) {
      nn = document.createElement('p'); nn.className = 's786pdp__upnote'; nn.setAttribute('data-s786-upnote', ''); nn.setAttribute('role', 'status'); nn.setAttribute('aria-live', 'polite'); nn.hidden = true;
      nn.innerHTML = '<span></span> <button type="button" class="s786pdp__undo">Undo</button>';
      st.parentNode.insertBefore(nn, st.nextSibling);
      nn.querySelector('button').addEventListener('click', undoUpgrade);
    }
    if (nn.classList.contains('is-undone')) return;
    if (state.upgraded && state.pack === 6) {
      var left = 6 - state.picks.length;
      nn.querySelector('span').textContent = 'Upgraded to the 6 set \u2014 ' + (left > 0 ? 'pick ' + left + ' more shade' + (left > 1 ? 's' : '') : 'all 6 shades picked') + '.';
      nn.querySelector('button').hidden = false; nn.hidden = false;
    } else { nn.hidden = true; }
  }

  function choosePack(n) {
    if (n === state.pack) return;
    state.upgraded = false;
    state.pack = n; state.edit = -1;
    if (n > 1) {
      if (!state.picks.length && byId[D.single.productId] && !byId[D.single.productId].disabled) { state.picks.push(pickFromButton(byId[D.single.productId])); state.last = D.single.name; }
      if (state.picks.length > n) state.picks = state.picks.slice(0, n);
    }
    msg('');
    render();
    try { var u = new URL(location.href); if (n > 1) u.searchParams.set('pack', n); else u.searchParams.delete('pack'); history.replaceState(history.state, '', u); } catch (e) {}
  }

  /* ---------- events ---------- */
  $$('.s786pdp__opt', root).forEach(function (o) { o.addEventListener('click', function () { choosePack(+o.dataset.pack); }); });
  $('.s786pdp__change-size', root).addEventListener('click', function () { $('.s786pdp__options', root).scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  swatches.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      var n = state.pack, idx = -1;
      state.picks.forEach(function (p, i) { if (p.id === b.dataset.id) idx = i; });
      if (state.edit >= 0) {
        if (idx >= 0 && idx !== state.edit) { var t = state.picks[state.edit]; state.picks[state.edit] = state.picks[idx]; state.picks[idx] = t; }
        else state.picks[state.edit] = pickFromButton(b);
        state.last = b.dataset.name; state.edit = -1; render();
        $('#s786pdp-review').scrollIntoView({ behavior: 'smooth', block: 'start' }); return;
      }
      if (idx >= 0) { state.picks.splice(idx, 1); state.last = state.picks.length ? state.picks[state.picks.length - 1].name : ''; }
      else if (state.picks.length < n) { state.picks.push(pickFromButton(b)); state.last = b.dataset.name; }
      else if (n === 4 && D.autoUpgrade !== false && D.sets[6] && D.sets[6].variant) { upgradeTo6(b); return; }
      else { msg('Your set is full. Tap a numbered shade to remove it, or use Edit below.'); return; }
      msg(''); render();
    });
  });
  root.addEventListener('click', function (e) { if (e.target.closest('[data-s786-cancel]')) { state.edit = -1; render(); } });
  $('[data-s786-rows]', root).addEventListener('click', function (e) {
    var b = e.target.closest('[data-edit]'); if (!b) return;
    state.edit = +b.dataset.edit; render();
    var first = $('.s786pdp__grid', root); if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  var qin = $('[data-s786-qty-input]', root);
  function syncQty() { var v = Math.max(1, parseInt(qin.value, 10) || 1); qin.value = v; $$('form[action*="/cart/add"] input[name="quantity"]').forEach(function (i) { i.value = v; }); return v; }
  $$('[data-s786-qty]', root).forEach(function (b) { b.addEventListener('click', function () { qin.value = Math.max(1, (parseInt(qin.value, 10) || 1) + (+b.dataset.s786Qty)); syncQty(); postRender(); }); });
  qin.addEventListener('change', function () { syncQty(); postRender(); });

  function msg(t, err) { var m = $('[data-s786-msg]', root); m.textContent = t || ''; m.classList.toggle('is-err', !!err); }

  var busy = false;
  $('[data-s786-atb]', root).addEventListener('click', function () {
    if (busy) return;
    var n = state.pack, qty = syncQty(), items = [];
    if (n === 1) {
      if (D.single.available === false) return;
      items.push({ id: +D.single.variant, quantity: qty });
    } else {
      if (state.picks.length < n) { msg('Pick ' + (n - state.picks.length) + ' more shade' + (n - state.picks.length > 1 ? 's' : '') + ' to complete your set.', true); $('#s786pdp-picker').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var props = { '_bundle-set': 'true' };
      state.picks.forEach(function (p, i) { props['Color ' + (i + 1)] = p.title; });
      items.push({ id: +D.sets[n].variant, quantity: qty, properties: props });
    }
    $$('[data-s786-addon]:checked', root).forEach(function (c) { items.push({ id: +c.value, quantity: 1 }); });
    busy = true; var btn = this, label = btn.textContent; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || r.status); return j; }); })
      .then(function () {
        btn.textContent = 'Added to Bag'; msg('');
        document.dispatchEvent(new CustomEvent('s786:added', { detail: { items: items } }));
        try { if (window.upcartRefreshCart) window.upcartRefreshCart(); } catch (x) {}
        setTimeout(function () { try { if (window.upcartOpenCart) window.upcartOpenCart(); } catch (x) {} }, 350);
        setTimeout(function () { btn.textContent = label; }, 2500);
      })
      .catch(function (err) { btn.textContent = label; msg('Sorry, we could not add this to your bag: ' + err.message, true); })
      .then(function () { busy = false; btn.removeAttribute('aria-busy'); });
  });

  /* ---------- keep scroll targets clear of the sticky header ---------- */
  function setHeaderOffset() {
    var h = 0;
    ['.header__outer-wrapper', '.shopify-section-group-header-group.header__outer-wrapper', 'header'].some(function (sel) { var e = $(sel); if (e) { var r = e.getBoundingClientRect(); if (r.height > 0 && r.height < 300) { h = r.height; return true; } } return false; });
    document.documentElement.style.setProperty('--s786-hdr', Math.round((h || 90) + 16) + 'px');
  }
  setHeaderOffset(); window.addEventListener('resize', setHeaderOffset); window.addEventListener('scroll', function () { if (!state.hdrDone) { state.hdrDone = true; setTimeout(setHeaderOffset, 300); } }, { passive: true });

  /* ---------- mobile: fade the floating cart bubble while buy-box controls pass under it ---------- */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var io = null, hits = new Set();
    function build() {
      if (io) io.disconnect(); hits.clear(); document.body.classList.remove('s786pdp-bubble-off');
      if (window.innerWidth >= 960) return;
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) hits.add(e.target); else hits.delete(e.target); });
        document.body.classList.toggle('s786pdp-bubble-off', hits.size > 0);
      }, { rootMargin: '-' + Math.max(0, window.innerHeight - 120) + 'px 0px 0px 0px' });
      $$('.s786pdp__btn, .s786pdp__atb, .s786pdp__row, .s786pdp__addon, .s786pdp__qty, .s786pdp__grid, .s786pdp__opt', root).forEach(function (el) { io.observe(el); });
    }
    build(); window.addEventListener('resize', function () { clearTimeout(state.ioT); state.ioT = setTimeout(build, 300); });
    state.rebuildIO = build;
  })();


  /* ================= v5 upgrades ================= */
  var postHooks = [];
  function postRender() { try { renderUpNote(); } catch (e) {} postHooks.forEach(function (f) { try { f(); } catch (e) {} }); }

  /* 2. Ryviu stars + count right under the title (moves the real widget, never hardcoded) */
  (function () {
    var tries = 0;
    function goReviews(e) {
      if (e) e.preventDefault();
      var t = $('ryviu-widget') || $('.r--widget-wapper'); if (!t) return;
      var y = t.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--s786-hdr'), 10) || 100);
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    function move() {
      var s = $('ryviu-widget-total');
      if (!s || !titleEl) { if (tries++ < 30) setTimeout(move, 500); return; }
      if ($('.s786pdp-stars')) return;
      var oldBlock = s.closest('.product__block');
      var a = document.createElement('a'); a.href = '#reviews'; a.className = 's786pdp-stars'; a.setAttribute('aria-label', 'Read customer reviews');
      titleEl.parentNode.insertBefore(a, titleEl.nextSibling); a.appendChild(s);
      a.addEventListener('click', goReviews);
      if (oldBlock && oldBlock !== a.closest('.product__block') && !oldBlock.textContent.trim()) oldBlock.style.display = 'none';
      if (state.placeHeart) setTimeout(state.placeHeart, 50);
      /* Ryviu fills the widget late (and in Safari/WebKit it can render the stars without the "4.9 (110 Reviews)" text
         after the move). Watch it: never hide while loading; if the stars are there but the text isn't, build the text
         from Ryviu's own reviews_data ("count;average") on the element; hide only if still empty after ~6s. */
      function sync() {
        var num = s.querySelector('.ryviu-number-widget'), fb = a.querySelector('.s786pdp-stars__fb');
        if (num && /\d/.test(num.textContent)) { if (fb) fb.remove(); a.style.display = ''; return true; }
        var d = (s.getAttribute('reviews_data') || '').split(';'), c = parseInt(d[0], 10), av = parseFloat(d[1]);
        if (c > 0 && av > 0 && s.querySelector('.r--stars')) {
          var avg = (Math.floor(av * 10 + 1e-6) / 10).toFixed(1);
          if (!fb) { fb = document.createElement('span'); fb.className = 'ryviu-number-widget s786pdp-stars__fb'; fb.style.fontSize = '13px'; a.appendChild(fb); }
          var html = '<span class="trw-avg">' + avg + '</span> <span class="trw-bracket">(</span> <span class="trw-count">' + c + '</span> <span class="trw-text"> Review' + (c === 1 ? '' : 's') + '</span> <span class="trw-bracket">)</span>';
          if (fb.innerHTML !== html) fb.innerHTML = html;
          a.style.display = ''; return true;
        }
        return false;
      }
      var rmo = new MutationObserver(function () { sync(); if (state.placeHeart) state.placeHeart(); });
      rmo.observe(s, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['reviews_data'] });
      sync();
      setTimeout(function () { if (!sync()) a.style.display = 'none'; }, 6000);
      setTimeout(function () { rmo.disconnect(); sync(); }, 30000);
    }
    move();
  })();

  /* 4 + 5. Claim badges + free-shipping line under the price */
  (function () {
    var pr = $('.product__price-and-ratings'); if (!pr) return;
    var box = document.createElement('div'); box.className = 's786pdp-top';
    box.innerHTML = '<div class="s786pdp-ship" data-s786-shipline><span class="s786pdp-ship__txt"></span><span class="s786pdp-ship__bar" aria-hidden="true"><i></i></span></div>';
    pr.parentNode.insertBefore(box, pr.nextSibling);
    function upd() {
      var el = $('[data-s786-shipline]', box), q = parseInt(qin.value, 10) || 1, n = state.pack;
      if (n === 1 && D.single.available === false) { el.hidden = true; return; }
      el.hidden = false;
      var line = (n === 1 ? D.single.price : D.sets[n].offer) * q, tot = line, rem = D.freeShip - tot;
      var txt = rem <= 0 ? 'Free US shipping' : 'Add ' + money(rem) + ' more for free US shipping';
      if (rem > 0 && rem < 100) { el.hidden = true; return; } /* within $1 of the threshold (4 set $54.99): an 'Add $0.01 more' nudge reads as silly, so show nothing */
      el.classList.toggle('is-done', rem <= 0);
      $('.s786pdp-ship__txt', el).textContent = txt;
      var bar = $('.s786pdp-ship__bar', el); bar.hidden = rem <= 0;
      $('i', bar).style.width = Math.max(4, Math.min(100, Math.round(tot / D.freeShip * 100))) + '%';
    }
    postHooks.push(upd);
  })();

  /* 3. Shade name tooltip on hover / tap */
  (function () {
    var tip = document.createElement('div'); tip.className = 's786pdp-tip'; tip.setAttribute('aria-hidden', 'true'); root.appendChild(tip);
    var hideT = null;
    function show(b, ms) {
      clearTimeout(hideT);
      tip.textContent = b.dataset.name + (b.classList.contains('is-out') ? ' (sold out)' : '');
      tip.classList.add('is-on');
      var rr = root.getBoundingClientRect(), br = b.getBoundingClientRect(), w = tip.offsetWidth, h = tip.offsetHeight;
      var left = Math.max(0, Math.min(rr.width - w, br.left - rr.left + br.width / 2 - w / 2));
      tip.style.left = left + 'px'; tip.style.top = (br.top - rr.top - h - 6) + 'px';
      if (ms) hideT = setTimeout(hide, ms);
    }
    function hide() { tip.classList.remove('is-on'); }
    var hover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    swatches.forEach(function (b) {
      if (hover) { b.addEventListener('mouseenter', function () { show(b); }); b.addEventListener('mouseleave', hide); b.addEventListener('focus', function () { show(b); }); b.addEventListener('blur', hide); }
      b.addEventListener('click', function () { show(b, 1600); });
      b.addEventListener('touchstart', function () { show(b, 1600); }, { passive: true });
    });
    window.addEventListener('scroll', function () { if (!hover) hide(); }, { passive: true });
  })();

  /* 1. Sticky Add to Bag bar on phones */
  (function () {
    var atb = $('[data-s786-atb]', root); if (D.sticky === false || !atb || !('IntersectionObserver' in window)) return;
    var bar = document.createElement('div'); bar.className = 's786pdp-sticky'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="s786pdp-sticky__info"><span class="s786pdp-sticky__opt"></span><span class="s786pdp-sticky__price"></span></div><button type="button" class="btn btn--medium btn--primary s786pdp-sticky__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    var sbtn = $('.s786pdp-sticky__btn', bar), atbVisible = true;
    function mirror() {
      var n = state.pack, q = parseInt(qin.value, 10) || 1;
      $('.s786pdp-sticky__opt', bar).textContent = n === 1 ? D.single.name + ' · Single' : n + ' Piece Set' + (state.picks.length < n ? ' · ' + state.picks.length + '/' + n + ' picked' : '');
      var sw = n === 1 ? 0 : (D.sets[n].was || 0);
      $('.s786pdp-sticky__price', bar).innerHTML = (sw > 0 ? '<s>' + money(sw * q) + '</s> ' : '') + money((n === 1 ? D.single.price : D.sets[n].offer) * q) + (q > 1 ? ' (' + q + ')' : '');
      sbtn.textContent = atb.textContent; sbtn.disabled = atb.disabled;
    }
    function vis() {
      var on = window.innerWidth < 750 && !atbVisible && atb.getBoundingClientRect().bottom < 0;
      if (on) { var pb = document.getElementById('PBarNextFrameWrapper'); var off = pb && pb.offsetHeight && getComputedStyle(pb).display !== 'none' ? pb.offsetHeight : 0; bar.style.bottom = off + 'px'; }
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); sbtn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('s786pdp-sticky-on', on);
    }
    new IntersectionObserver(function (es) { atbVisible = es[0].isIntersecting; vis(); }).observe(atb);
    new MutationObserver(mirror).observe(atb, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    window.addEventListener('scroll', vis, { passive: true }); window.addEventListener('resize', vis);
    sbtn.addEventListener('click', function () { atb.click(); });
    postHooks.push(mirror); mirror();
  })();

  /* ---------- init ---------- */
  render();
  try { var pk = +new URLSearchParams(location.search).get('pack'); if (pk === 4 || pk === 6) choosePack(pk); } catch (e) {}
})();
